import { Component, OnInit } from '@angular/core';
import {StsNotificationType} from '../../../models/sts-notification-type';
import {StsNotification} from '../../../models/sts-notification.model';
import { StsCmsService } from '../../../services/sts-cms-service.service';

@Component({
  selector: 'app-account-voided',
  templateUrl: './account-voided.component.html',
  styleUrls: ['./account-voided.component.scss']
})
export class AccountVoidedComponent implements OnInit {
  public errors: StsNotification[] = [];

  constructor(private cmsService: StsCmsService) { }

  ngOnInit() {
    let e = new StsNotification();
    e.level = StsNotificationType.Error;
    e.code = 'sts-form forgot-instruction-top';

    this.cmsService.getText(e.code).subscribe(res => {
      e.description = res ? res : 'Sorry that link is no longer available; if the problem persists, please contact us.';
      this.errors = [e];
    });

  }

}
